import styled from 'styled-components';

import { SelectField } from 'components/fields';

export const StyledSelectFields = styled(SelectField)`
  flex: ${({ theme }) => (theme.responsive.isTablet ? 1 : 'unset')};
`;
